import { BlogSection } from '@/types/blog';

export const neurofinanceSection: BlogSection = {
  id: 'neurofinance',
  title: 'Die Biologie der Entscheidung: Neurofinance',
  content: `
    <p>
      Warum fallen uns Finanzentscheidungen oft so schwer? Die Wissenschaft der Neuroökonomie 
      (Neurofinance) zeigt, dass unser Gehirn unter Stress in den Überlebensmodus schaltet.
    </p>
    
    <p>
      Amygdala-Hijack: Bei Marktpanik übernimmt das Angstzentrum (Amygdala) die Kontrolle über den 
      präfrontalen Kortex (unseren „inneren CEO"). Das Ergebnis sind irrationale Panikverkäufe oder Schockstarre.
    </p>
    
    <p>
      Bandwidth Tax (Bandbreiten-Steuer): Chronische Geldsorgen blockieren geistige Kapazität wie ein 
      Hintergrundprozess am PC. Studien belegen, dass dies die kognitive Leistungsfähigkeit um 
      vergleichbar 13 IQ-Punkte senken kann.
    </p>
    
    <p>
      Im Coaching schaffen wir Entscheidungsrituale und Vorab-Regeln, damit Sie in Stressphasen nicht 
      aus dem Bauch heraus handeln, sondern einem vorher definierten Plan folgen können.
    </p>
  `
};
